import React from "react";

const ConfirmedBooking = () => {
  const viewBooking = () => {
    alert("View booking details functionality would go here");
    // window.location.href = '/booking-details';
  };

  const rescheduleBooking = () => {
    alert("Reschedule inspection functionality would go here");
    // Open reschedule modal or page
  };

  return (
    <div className="w-max mx-auto p-5 bg-gray-100 text-gray-800">
      <header className="text-center py-5">
        <div className="text-2xl font-bold text-orange-600 mb-2">CARS24</div>
        <div className="text-gray-600">Your car inspection is booked!</div>
      </header>

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-10 h-10 text-green-500"
            >
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
            </svg>
          </div>
          <h1 className="text-2xl font-semibold text-green-500 mb-2">
            Booking Confirmed
          </h1>
          <p className="text-gray-600">
            Your booking ID is{" "}
            <span className="font-semibold text-orange-600">#C24B789012</span>
          </p>
        </div>

        <div className="flex mb-5 p-4 bg-gray-200 rounded-lg">
          <img
            src="https://via.placeholder.com/300x200?text=Hyundai+Creta"
            alt="Hyundai Creta"
            className="w-30 h-20 object-cover rounded-lg mr-4"
          />
          <div>
            <h3 className="text-lg font-semibold">Hyundai Creta SX (Petrol)</h3>
            <p className="text-gray-600">2020 | 25,000 km | White</p>
            <p className="text-gray-600">Automatic | Mumbai</p>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-3 border-b pb-2">
            Inspection Details
          </h3>
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Date & Time</span>
            <span className="font-medium text-right">
              18 June 2023, 2:00 PM
            </span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Inspection Address</span>
            <span className="font-medium text-right">
              12/B, Palm Heights, Andheri East, Mumbai - 400069
            </span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Inspection Manager</span>
            <span className="font-medium text-right">
              Rahul Sharma (+91 98765 43210)
            </span>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-3 border-b pb-2">
            Estimated Price Range
          </h3>
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Based on details provided</span>
            <span className="font-medium text-right">
              ₹9,50,000 - ₹10,25,000
            </span>
          </div>
          <p className="text-gray-600 text-sm mt-2">
            Final price will be confirmed after physical inspection
          </p>
        </div>

        <div className="flex flex-col gap-3 mt-6">
          <button
            className="bg-orange-600 text-white py-3 rounded-lg font-semibold"
            onClick={viewBooking}
          >
            View Booking Details
          </button>
          <button
            className="bg-white text-orange-600 border border-orange-600 py-3 rounded-lg font-semibold"
            onClick={rescheduleBooking}
          >
            Reschedule Inspection
          </button>
        </div>
      </div>

      <p className="text-center text-gray-600 text-sm mt-6">
        Need help? Call us at
        <a href="tel:+9118001234567" className="text-orange-600 no-underline">
          {" "}
          1800 123 4567
        </a>
      </p>
    </div>
  );
};

export default ConfirmedBooking;
